import type { ConfigContextValue } from '@core/context';

import { useContext, useMemo } from 'react';

import { ConfigContext, ProjectContext } from '@core/context';

/**
 * Determines if the app is in dry run mode based on environment and user flags.
 * Returns true if previewEnvironment, dryRunFlag, and superHubPreviewFlag are all true.
 */
const useIsDryRunMode = () => {
  const config = useContext(ConfigContext) as ConfigContextValue;
  const { project } = useContext(ProjectContext) || {};

  const previewEnvironment = config?.shMigration.migrationPreview;
  const superHubPreviewFlag = project.flags.superHubPreview;
  const migrationType = project.git?.migrationType;

  const isDryRunMode = useMemo(() => {
    return Boolean(previewEnvironment && superHubPreviewFlag && migrationType === 'dryRun');
  }, [previewEnvironment, superHubPreviewFlag, migrationType]);

  return { isDryRunMode };
};

export default useIsDryRunMode;
